"use strict";
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b ||= {})
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
import classNames from "classnames";
import React, {
  useState
} from "react";
import { Transition } from "react-transition-group";
import { Tick, IconSize, ListMarkerSquare, Warning } from "../../icons";
import { forceReflow } from "../../../utils";
import { darkTheme, duration, lightTheme } from "../../../tokens/tokens-css";
import { Label } from "../Label";
import * as styles from "./Checkbox-css";
import Tooltip from "../Tooltip/Tooltip";
import { Expandable } from "../../behaviors/Expandable";
import { Text } from "../Text";
export function Checkbox(_a) {
  var _b = _a, {
    size = "s",
    theme,
    id,
    label,
    checked,
    disabled,
    labelHidden,
    role,
    onChange,
    onFocus,
    onBlur,
    className,
    tooltip,
    error
  } = _b, props = __objRest(_b, [
    "size",
    "theme",
    "id",
    "label",
    "checked",
    "disabled",
    "labelHidden",
    "role",
    "onChange",
    "onFocus",
    "onBlur",
    "className",
    "tooltip",
    "error"
  ]);
  const [showTooltip, setShowTooltip] = useState(void 0);
  const checkboxId = `checkbox-${id}`;
  const labelId = `checkbox-${id}-label`;
  const tooltipId = `checkbox-${id}-tooltip`;
  const errorId = `checkbox-${id}-error`;
  const handleChange = (event) => {
    onChange(!checked, id, event);
  };
  const renderCheckbox = () => /* @__PURE__ */ React.createElement(
    "button",
    {
      className: styles.checkbox,
      onClick: handleChange,
      role: role != null ? role : "checkbox",
      "aria-labelledby": labelId,
      "aria-checked": checked,
      "aria-disabled": disabled,
      "aria-describedby": error ? errorId : void 0,
      "aria-invalid": !!error,
      disabled,
      onFocus,
      onBlur,
      id: checkboxId,
      type: "button"
    },
    /* @__PURE__ */ React.createElement(Transition, { mountOnEnter: true, unmountOnExit: true, in: checked === true, timeout: duration.m, onEnter: forceReflow }, (status) => /* @__PURE__ */ React.createElement(
      Tick,
      {
        className: styles.indicator({ visible: ["entering", "entered"].includes(status) }),
        size: IconSize.Small
      }
    )),
    /* @__PURE__ */ React.createElement(Transition, { mountOnEnter: true, unmountOnExit: true, in: checked === "mixed", timeout: duration.m, onEnter: forceReflow }, (status) => /* @__PURE__ */ React.createElement(
      ListMarkerSquare,
      {
        className: styles.indicator({ visible: ["entering", "entered"].includes(status) }),
        size: IconSize.Small
      }
    ))
  );
  return /* @__PURE__ */ React.createElement(
    "div",
    {
      className: classNames(
        styles.container,
        {
          [lightTheme]: theme === "light",
          [darkTheme]: theme === "dark"
        },
        className
      )
    },
    /* @__PURE__ */ React.createElement(
      "div",
      __spreadValues({
        className: styles.content({ disabled, size }),
        onMouseEnter: () => setShowTooltip(true),
        onMouseLeave: () => setShowTooltip(false),
        onFocus: () => setShowTooltip(true),
        onBlur: () => setShowTooltip(false),
        tabIndex: disabled ? 0 : void 0,
        "aria-describedby": disabled ? tooltipId : void 0
      }, props),
      !tooltip && renderCheckbox(),
      !!tooltip && /* @__PURE__ */ React.createElement(Tooltip, __spreadProps(__spreadValues({}, tooltip), { show: tooltip.show || showTooltip }), renderCheckbox()),
      /* @__PURE__ */ React.createElement(
        Label,
        {
          long: true,
          disabled,
          hidden: labelHidden,
          className: styles.label({ hidden: labelHidden }),
          element: "label",
          htmlFor: checkboxId,
          id: labelId
        },
        label
      )
    ),
    /* @__PURE__ */ React.createElement(Expandable, { expanded: !!error, timeout: duration.s }, ({ expandableElementRef }) => /* @__PURE__ */ React.createElement("div", { "aria-live": "polite", ref: expandableElementRef, id: errorId, className: styles.error }, /* @__PURE__ */ React.createElement(Warning, { "aria-hidden": true, size: IconSize.Small, color: "critical", className: styles.errorIcon }), /* @__PURE__ */ React.createElement(Text, { size: "s", lineHeight: "compact" }, error)))
  );
}
